/// <amd-module name="Wiki/ViewCommon/Utils/PageHelper" />
import { WikiPage } from "Wiki/Clients/Wiki/Contracts/Wiki";

export function flattenWikiPage(page: WikiPage | undefined): WikiPage[] {
    if (!page) {
        return [];
    }

    const pages: WikiPage[] = [];
    let unprocessedPages: WikiPage[] = [page];

    while (unprocessedPages.length > 0) {
        const tempPages: WikiPage[] = [];

        for (const unprocessedPage of unprocessedPages) {
            pages.push(unprocessedPage);
            tempPages.push(...unprocessedPage.subPages);
        }

        unprocessedPages = [];
        unprocessedPages.push(...tempPages);
    }

    return pages;
}
